import { useContext } from 'react';

import tableTypes from '../../../../utils/filesTableTypes';
import { FilesSdsPtContext } from '../../../../context/FilesSdsPtContext';
import { AttachedFilesPermissions } from '../../../MonthlyServiceRequest/RequestDetailTypes';
import { DetailRequest } from '../../../../utils/globalPropTypes';

import TableFiles from './TableFiles';

const FilesDetailServiceRequestApprover = (props) => {
  const { detailsHeader, filesPermissions } = props;

  const { estadoEnum, tipoAsignacion, id } = detailsHeader;

  const { dataFilesPt } = useContext(FilesSdsPtContext);

  return (
    <>
      {estadoEnum >= 3 && (
        <TableFiles
          columnSds={false}
          details={detailsHeader}
          disabledButtonDownloadDelete={!dataFilesPt.length}
          id={id}
          isMonthly={tipoAsignacion?.id === 3}
          onlyButtonDeletedFiles={false}
          permissions={filesPermissions.workPart}
          sds={false}
          type={tableTypes.pt}
        />
      )}
    </>
  );
};

export default FilesDetailServiceRequestApprover;

FilesDetailServiceRequestApprover.propTypes = {
  detailsHeader: DetailRequest.isRequired,
  filesPermissions: AttachedFilesPermissions
};

FilesDetailServiceRequestApprover.defaultProps = {
  filesPermissions: {
    visualize: false,
    write: false
  }
};
